import React from "react";
import Slider from "react-slick";

const LogoSlider = () => {
  const logos = [
    { id: 1, img: require('../assets/img/logo/logo1.png')},
    { id: 2, img: require('../assets/img/logo/logo2.png')},
    { id: 3, img: require('../assets/img/logo/logo3.png')},
    { id: 4, img: require('../assets/img/logo/logo4.png')},
    { id: 5, img: require('../assets/img/logo/logo5.png')},
  ];

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 3000, // Speed of sliding (milliseconds)
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0, // No delay between slides
    cssEase: "linear", // Continuous smooth scrolling
    pauseOnHover: false, // Keeps running even when hovered
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 4,
        },
      },
    ],
  };

  return (
    <div className="logo-slider">
      <Slider {...settings}>
        {logos.map((logo) => (
          <div key={logo.id} className="logo-item">
            <img src={logo.img} alt={`v-strong contractor llc`} className="img-fluid" />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default LogoSlider;
